<!-- 车站管理 -->
<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove } from "./api";
export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, add, update, remove },
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: "站点编码",
            prop: "stationCode",
            overHidden: true, // 表格超出隐藏
          },
          {
            label: "站点名称",
            prop: "stationName",
            maxlength: 60,
            search: true,
            rules: [
              {
                required: true,
                message: "请输入车站名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "备注",
            prop: "remark",
            overHidden: true, // 表格超出隐藏
          },
        ],
      },
    };
  },
};
</script>
<style scoped lang="scss"></style>
